import { render, staticRenderFns } from "./fileTransfer.vue?vue&type=template&id=33d5986d&scoped=true"
import script from "./fileTransfer.vue?vue&type=script&lang=js"
export * from "./fileTransfer.vue?vue&type=script&lang=js"
import style0 from "./fileTransfer.vue?vue&type=style&index=0&id=33d5986d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d5986d",
  null
  
)

export default component.exports